<script lang="ts">
import type { StudyChapterProblemSlideProps } from '$lib/components/study/slide-layout-types'
import LineChartGrowthCard from '../cards/LineChartGrowthCard.svelte'
import StudySlideTextCard from '../cards/StudySlideTextCard.svelte'
import StudySlide from '../StudySlide.svelte'
import StudySlideContent from '../StudySlideContent.svelte'

/**
 * “Chapter 01 · The Challenge” slide: eyebrow, headline, 3-up cards + highlight band, growth chart.
 * `eyebrow`, `headline`, and `highlight` use `{@html}` — trusted study copy only.
 */
let {
  id,
  active = false,
  extraBottom = false,
  contentClass = '',
  eyebrow,
  headline,
  textCards,
  highlight,
  growthChart,
}: StudyChapterProblemSlideProps = $props()

const innClass = $derived(['study-slide-chapter-problem', contentClass].filter(Boolean).join(' '))
</script>

<StudySlide {id} {active} {extraBottom}>
  <StudySlideContent maxWidth="960px" contentClass={innClass}>
    <div class="ey">{@html eyebrow}</div>
    <div class="hl" style="margin-bottom:.9rem;">{@html headline}</div>
    <div class="hr"></div>
    <div class="tc study-slide-chapter-problem__tc">
      <div>
        <div
          class="ttc study-slide-chapter-problem__ttc"
          style="--ttc-cols:{Math.min(textCards.length, 3)}"
        >
          {#each textCards as card}
            <StudySlideTextCard {...card} />
          {/each}
        </div>
        <div class="hb">{@html highlight}</div>
      </div>
      <div class="cc">
        <LineChartGrowthCard {active} {...growthChart} />
      </div>
    </div>
  </StudySlideContent>
</StudySlide>

<style>
/*
   * Viewport can be ~1163px while logo clearance leaves <920px for `.inn` — keep grids driven by
   * *content* width, not viewport breakpoints (see StudySlidePresentation `.tc` / `.ttc`).
   */
:global(.study-slide-chapter-problem) {
  container-type: inline-size;
  container-name: study-chapter-problem;
}
:global(.study-slide-chapter-problem .study-slide-chapter-problem__tc) {
  margin-top: 0.85rem;
  gap: 1.9rem;
}
:global(.study-slide-chapter-problem .study-slide-chapter-problem__ttc) {
  margin-bottom: 0.85rem;
  /* Fill exactly as many columns as there are cards (2 cards → 2 cols, not 3 with an empty slot).
     The container query below still collapses to a single column on narrow content. */
  grid-template-columns: repeat(var(--ttc-cols, 3), minmax(0, 1fr));
}
@container study-chapter-problem (max-width: 920px) {
  :global(.study-slide-chapter-problem .tc) {
    grid-template-columns: minmax(0, 1fr);
    gap: 1rem;
  }
  :global(.study-slide-chapter-problem .ttc) {
    grid-template-columns: minmax(0, 1fr);
    gap: 0.65rem;
  }
}
</style>
